export enum FieldTypeEnum {
    STRING,
    NUMBER,
    DATETIME,
    DATERANGE,
    OBJECT,
    ARRAY,
    OBJECTARRAY,
    BOOLEAN,
    EMAIL,
}

// type BtnColorTypes = { [K in ButtonType]: { type: K, background: string, textColor: string } };